import React from "react";

const AdminDashboardPage = () => {
  return <h1>Admin Dashboard – Samo za admina!</h1>;
};

export default AdminDashboardPage;
